"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var internal_compatibility_1 = require("rxjs/internal-compatibility");
var API_URL = twGlobal.APIEndpoint;
var FaqsSearchForm = /** @class */ (function () {
    function FaqsSearchForm() {
    }
    FaqsSearchForm.prototype.onLoadEach = function ($element) {
        var $searchInput = $element.$(".FaqsSearchForm__input");
        var $resultsWrap = $element.$(".FaqsSearchForm__results");
        var untilRefresh = (0, DOMScript_1.makeUntilRefresh)();
        var trackEmptySearch = function (isEmpty, label) {
            if (isEmpty)
                window.dataLayer.push({
                    event: "zeroSearch",
                    eventName: "view_search_result",
                    searchTerm: label,
                    resultN: "0"
                });
        };
        var highlightResults = function (search, selector, $element) {
            $element.$$(selector).forEach(function (item) {
                var words = search.split(" ");
                words.forEach(function (word) {
                    if (word == " " || word.length < 2)
                        return;
                    var itemLabel = item.innerHTML;
                    var reg = new RegExp("(" + word + ")", "gi");
                    item.innerHTML = itemLabel.replace(reg, "<mark>$1</mark>");
                });
            });
        };
        untilRefresh((0, rxjs_1.fromEvent)(document, "click"))
            .pipe((0, operators_1.map)(function (e) { return e.target; }), (0, operators_1.filter)(function (e) {
            var _a;
            return !((_a = $element.$(".wrap")) === null || _a === void 0 ? void 0 : _a.contains(e));
        }))
            .subscribe(function () { return $resultsWrap.classList.remove("--open"); });
        untilRefresh((0, rxjs_1.fromEvent)($searchInput, "keyup"))
            .pipe((0, operators_1.debounceTime)(500), (0, operators_1.map)(function (e) { return e.target.value; }), (0, operators_1.distinctUntilChanged)(), (0, operators_1.filter)(function (e) {
            var hasMinChars = e.length > 2;
            if (!hasMinChars) {
                $resultsWrap.classList.remove("--open");
                $resultsWrap.classList.remove("--animate");
                $resultsWrap.innerHTML = "";
            }
            return hasMinChars;
        }), (0, operators_1.switchMap)(function (s) {
            var query = new URLSearchParams({ s: s }).toString();
            return (0, internal_compatibility_1.ajaxGetJSON)("".concat(API_URL, "tw/v1/search-faqs/?").concat(query));
        }), (0, operators_1.catchError)(function (_) { return (0, rxjs_1.of)({ response: { html: "" } }); }))
            .subscribe(function (_a) {
            var _b = _a === void 0 ? {} : _a, response = _b.response;
            var _c = response.html, html = _c === void 0 ? "" : _c, _d = response.parameters, parameters = _d === void 0 ? { s: "" } : _d;
            var alreadyAnimated = $resultsWrap.classList.contains("--animate");
            if (!alreadyAnimated)
                $resultsWrap.classList.add("--animate");
            $resultsWrap.$classAddOrRemoveIf(html.length > 0, "--open");
            $resultsWrap.innerHTML = html;
            highlightResults(parameters.s, ".item", $resultsWrap);
            setTimeout(function () {
                return trackEmptySearch(!$resultsWrap.querySelector(".items"), parameters.s);
            }, 0);
        });
    };
    FaqsSearchForm = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".FaqsSearchForm__form",
            isElementArray: true
        })
    ], FaqsSearchForm);
    return FaqsSearchForm;
}());
new FaqsSearchForm();
